<template>
  <v-content>
    <v-container
      fill-height
      fluid>
      <v-layout
        align-center
        justify-center>
        <v-flex
          xs12
          sm8
          md4>
          <div class="text-xs-center mb-4">
            <img
              :src="require('@/assets/img/logo-ois.png')"
              alt="PT. Ornova Integra Solusi"
              class="login-logo">
          </div>
          <v-card
            class="elevation-12">
            <v-toolbar
              color="secondary">
              <v-toolbar-title class="white--text">OIS Login Form</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form >
                <v-text-field
                  ref="username"
                  v-model="username"
                  :rules="[() => !!username || 'This field is required']"
                  prepend-icon="mdi-account"
                  label="Login"
                  placeholder="Username"
                  required
                />
                <v-text-field
                  ref="password"
                  v-model="password"
                  :rules="[() => !!password || 'This field is required']"
                  :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  :type="showPassword ? 'text' : 'password'"
                  prepend-icon="mdi-lock"
                  label="Password"
                  placeholder="*********"
                  counter
                  required
                  @keydown.enter="login"
                  @click:append="showPassword = !showPassword"
                />
              </v-form>
            </v-card-text>
            <v-divider class="mt-5"/>
            <v-card-actions>
              <v-spacer/>
              <v-btn
                align-center
                justify-center
                color="success"
                @click="login">Login
              </v-btn>
            </v-card-actions>
            <v-snackbar
              v-model="snackbar"
              :color="color"
              :top="true"
            >
              {{ errorMessages }}
              <v-btn
                flat
                @click="snackbar = false"
              >
                Close
              </v-btn>
            </v-snackbar>
          </v-card>
        </v-flex>
      </v-layout>

    </v-container>
  </v-content>
</template>

<script>
export default {
  data: function () {
    return {
      username: '',
      password: '',
      errorMessages: 'Incorrect login info',
      snackbar: false,
      color: 'error',
      showPassword: false
    }
  },
  mounted () {

  },
  // Sends action to Vuex that will log you in and redirect to the dash otherwise, error
  methods: {
    login: async function () {
      if (this.username === '' || this.password === '') {
          this.snackbar = true
          this.errorMessages = 'Username / Password are empty'
          return false
      }
      let username = this.username
      let password = this.password
      try {
        await this.$store.dispatch('login', { username, password })
        await this.$router.push('/dashboard')
        // await this.$store.dispatch('autoRefreshToken') // invoked only when login (new tab wont do this)
      } catch (err) {
        console.log(err)
        this.snackbar = true
        this.errorMessages = 'Username & password are wrong or Username is inactive!'
      }
    }
  },
  metaInfo () {
    return {
      title: 'OIS Web Admin | Login'
    }
  }
}
</script>

<style scoped>
.login-logo {
  width: 70%;
  max-width: 260px;
  height: auto;
}
</style>
